/** 散布図サムネを画面上でこの半径（px）程度に保つ */
export const SCATTER_THUMB_TARGET_RADIUS_PX = 9;
/** ホバー用ヒット領域の半径（px） */
export const SCATTER_HIT_TARGET_RADIUS_PX = 15;

/**
 * 逆スケールの強さ。1 に近いほど画面上サイズが一定。
 * 1 未満にすると横幅が広いときマーカーがやや大きく（狭いときはやや小さく）なる。
 */
export const SCATTER_MARKER_INVERSE_SCALE_EXPONENT = 0.88;

/**
 * 均一スケールされた SVG で、画面上で targetRadiusPx を基準に viewBox 上の半径を求める。
 * 表示幅に対して `ratio^(逆スケール指数)` で補正し、完全な 1/ratio より緩やかに追従する。
 */
export function markerRadiusInViewBox(
  targetRadiusPx: number,
  svgClientWidthPx: number,
  viewBoxWidth: number
): number {
  const w = svgClientWidthPx > 0 ? svgClientWidthPx : viewBoxWidth;
  const ratio = w / viewBoxWidth;
  return targetRadiusPx / Math.pow(ratio, SCATTER_MARKER_INVERSE_SCALE_EXPONENT);
}
